import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { IsoCountryCode } from 'src/app/model/configuration';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { OperationResult } from '@tb/auth';
import { ServiceUtilsService } from 'src/app/core/services/service-utils.service';
import { MagoWebService } from 'src/app/core/services/mago-web.service';
import { CountryService } from 'src/app/core/services/country.service';
import { StoreRolesService } from 'src/app/core/services/store-role.service';
import { CmsObject } from 'src/app/model/cmsobject';
import { CmsService } from 'src/app/core/services/cms.service';
import { MagoCloudService } from 'src/app/core/services/mago-cloud.service';

@Component({
    selector: 'ms-country-selection',
    templateUrl: './country-selection.component.html',
    styleUrls: ['./country-selection.component.scss'],
})
export class CountrySelectionComponent implements OnInit {
    @Output() countrySelectedDescri = new EventEmitter<string>();
    @Output() countrySelectedValue = new EventEmitter<string>();
    @Input() isAmazonDsp = false;
    @Input() isModifyStatus = false;
    @Input() isMagoWeb = false;
    public isoCountryCodeList: IsoCountryCode[] = [];
    public isoCountryCodeAllowedList: String[] = [];
    public countrySelected = 'none';
    public countryDescription = '';
    public allowedCountry = '';
    language: string;
    public cmsObj: CmsObject[];
    countrySelectionHint: string;

    constructor(
        private workflow: WorkFlowService,
        private configurationService: ConfigurationService,
        private serviceUtilsService: ServiceUtilsService,
        public magoWebService: MagoWebService,
        public countryService: CountryService,
        private storeRoleService: StoreRolesService,
        public cmsService: CmsService,
        public magoCloudService: MagoCloudService
    ) {}

    async ngOnInit() {
        this.getCmsObj();
        // if (this.isAmazonDsp) {
        //     let opResDspCountries: OperationResult = await this.serviceUtilsService.getStoreParameterValue('amazon_dsp_AllowedCountries');
        //     let opResDspCountriesContent = opResDspCountries.Content.Value as string;
        //     //this.amazonDspService.setAllowedCountriesAmazonDsp(opResDspCountriesContent);
        //     this.countrySelected = this.amazonDspService?.amazonDspCountryValue;
        //     this.countryService.setCountry(this.countrySelected);
        //     this.isoCountryCodeAllowedList = this.amazonDspService.amazonDspAllowedCountries.split(';');
        //     await this.getSupportedIsoCountries();
        //     if (this.amazonDspService.isModifyStatus) {
        //         this.countryDescription = await this.serviceUtilsService.getCountryDescription(this.countrySelected);
        //     }
        // } else {
        this.countrySelected = this.countryService.countrySelected;
        this.countryService.setCountry(this.isMagoWeb ? this.magoWebService.countryValue : this.magoCloudService?.countryValue);
        await this.getSupportedIsoCountries();
        if (this.magoCloudService.isModifyStatus || (this.magoWebService.isModifyStatus && !this.storeRoleService.IsInternal)) {
            this.countryDescription = await this.serviceUtilsService.getCountryDescription(this.countrySelected);
            //}
        }
    }

    async getCmsObj() {
        this.language = this.workflow.getLanguageForCms();
        //recupero le stringhe della pagina
        this.cmsObj = await this.cmsService.getCmsObj(this.language, 'countryselection');
        this.countrySelectionHint = this.cmsObj.find((x) => x.ContentName == 'countryselection.hint').ContentTranslation;
    }
    public async onCountryChange(event: any) {
        this.countryDescription = await this.serviceUtilsService.getCountryDescription(event.value);
        this.countryService.setCountry(event.value);
        this.countrySelectedValue.emit(event.value);
        this.countrySelectedDescri.emit(this.countryDescription);
    }

    async getSupportedIsoCountries() {
        let culture = this.workflow.getLanguageForCms();
        let data: IsoCountryCode[] = await this.configurationService.getAllSupportedISOCountryCode(culture);
        if (data === null || data === undefined) {
            return;
        }
        if (this.isoCountryCodeAllowedList && this.isoCountryCodeAllowedList.length > 0)
            this.getIsoCountryAllowed(data, this.isoCountryCodeAllowedList);
        else this.isoCountryCodeList = data;
    }

    async getIsoCountryAllowed(allCountryCode: IsoCountryCode[], selectedCountry: String[]) {
        let list: IsoCountryCode[] = [];
        allCountryCode.forEach((f) => {
            {
                let opt = f.ISOCountryCode;
                if (selectedCountry.indexOf(opt) > -1) {
                    list.push(f);
                }
            }
        });
        this.isoCountryCodeList = list;
    }

    public getFormattedInfo(temp: boolean) {
        return !temp ? '(*)' : '';
    }
}
